export function meetsCondition(value, validation) {
  const conditionType = validation?.conditionType;
  const conditionValue =
    validation?.conditonValue !== undefined
      ? validation?.conditonValue
      : validation?.conditionValue;

  if (conditionType === undefined || conditionType === null) return true;
  const cv = Number(conditionValue);
  if (Number.isNaN(cv)) return true;

  const num = Number(value);
  if (Number.isNaN(num)) return false;

  switch (conditionType) {
    case "<":
      return num < cv;
    case "<=":
      return num <= cv;
    case "=":
    case "==":
      return num === cv;
    case ">=":
      return num >= cv;
    case ">":
      return num > cv;
    default:
      return true;
  }
}

export function clampMinIfCondition(value, minValue, validation) {
  const num = Number(value);
  const min = Number(minValue);
  if (Number.isNaN(num)) return value;
  if (minValue === undefined || Number.isNaN(min)) return value;
  return meetsCondition(num, validation) ? Math.max(min, num) : num;
}

export function isExceedMaxIfCondition(value, maxValue, validation) {
  const num = Number(value);
  const max = Number(maxValue);
  if (Number.isNaN(num)) return false;
  if (!meetsCondition(num, validation)) return false;
  if (maxValue !== undefined && !Number.isNaN(max) && num > max) return true;
  return num > 2147483647;
}

export function applyRoundIfCondition(value, roundOffQty, validation) {
  const num = Number(value);
  const step = Number(roundOffQty);
  if (Number.isNaN(num)) return value;
  if (roundOffQty === undefined || Number.isNaN(step) || step <= 0) return num;
  if (!meetsCondition(num, validation)) return num;
  return Math.ceil(Math.max(1, num) / step) * step;
}

export function applyPercentageIncreaseIfCondition(value, percentage, validation) {
  const num = Number(value);
  const pct = Number(percentage);
  if (Number.isNaN(num)) return value;
  if (percentage === undefined || Number.isNaN(pct)) return num;
  if (!meetsCondition(num, validation)) return num;
  const inc = Math.round(num * (pct / 100));
  return num + inc;
}
